import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import 'shared/helpers/global-declarations';
import { WebAppState } from 'web/state/store.web';
import PageContainer from '../page-container/page-container';
import './home.scss';
import { Spinner } from '../spinner/spinner';

interface HomeState {
	column?: number;
	details: { [id: string]: string } | null;
}

const mapStateToProps = (state: WebAppState) => {
	return {
		navigation: state.navigation,
		isSyncing: state.offline.isSyncing,
	};
};
const mapDispatchToProps = (dispatch: Dispatch) => ({});

type HomeProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class Home extends React.PureComponent<HomeProps, HomeState> {
	public UNSAFE_componentWillMount() {
		this.setState({ details: null });
	}

	public render() {
		return <PageContainer className="home">{this.props.isSyncing && <Spinner />}</PageContainer>;
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
